import {
  BLOOM_RADIUS,
  BLOOM_STRENGTH,
  BLOOM_THRESHOLD,
  CAMERA_Z,
  TONE_EXPOSURE,
} from "../particles/visualBounds.ts";
import { clamp as clampNum } from "../utils/math.ts";

const KEY = "gestureverse.look.v1";

export interface VisualLook {
  exposure: number;
  bloomStrength: number;
  bloomRadius: number;
  bloomThreshold: number;
  pointSizeMult: number;
  cameraZ: number;
}

export const DEFAULT_LOOK: VisualLook = {
  exposure: TONE_EXPOSURE,
  bloomStrength: BLOOM_STRENGTH,
  bloomRadius: BLOOM_RADIUS,
  bloomThreshold: BLOOM_THRESHOLD,
  pointSizeMult: 1,
  cameraZ: CAMERA_Z,
};

export function validateLook(input: unknown): VisualLook {
  const raw = input && typeof input === "object" ? (input as Record<string, unknown>) : {};
  const num = (key: string, fallback: number, min: number, max: number) => {
    const n = typeof raw[key] === "number" ? (raw[key] as number) : Number(raw[key]);
    if (!Number.isFinite(n)) return fallback;
    return clampNum(n, min, max);
  };
  return {
    exposure: num("exposure", DEFAULT_LOOK.exposure, 0.75, 1.12),
    bloomStrength: num("bloomStrength", DEFAULT_LOOK.bloomStrength, 0, 0.68),
    bloomRadius: num("bloomRadius", DEFAULT_LOOK.bloomRadius, 0.12, 0.32),
    bloomThreshold: num("bloomThreshold", DEFAULT_LOOK.bloomThreshold, 0.48, 0.78),
    pointSizeMult: num("pointSizeMult", DEFAULT_LOOK.pointSizeMult, 0.75, 1.35),
    cameraZ: num("cameraZ", DEFAULT_LOOK.cameraZ, 11, 18),
  };
}

export function loadLook(): VisualLook {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_LOOK };
    return validateLook(JSON.parse(raw) as unknown);
  } catch {
    return { ...DEFAULT_LOOK };
  }
}

export function saveLook(look: VisualLook): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(validateLook(look)));
  } catch {
    /* ignore */
  }
}
